import React from 'react';
export function OfflineIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.707 15.293a1 1 0 00-1.414 0L12 16.586l-1.293-1.293a1 1 0 00-1.414 1.414L10.586 18l-1.293 1.293a1 1 0 101.414 1.414L12 19.414l1.293 1.293a1 1 0 001.414-1.414L13.414 18l1.293-1.293a1 1 0 000-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.309 7.015a6.979 6.979 0 00-13.21 4.097A4 4 0 005 19h2a1 1 0 100-2H5a2 2 0 111.414-3.413 1 1 0 001.414-1.414 3.968 3.968 0 00-1.664-.982A4.762 4.762 0 016 10.001a4.988 4.988 0 019.18-2.715 5.924 5.924 0 00-2.934 2.057 1 1 0 001.588 1.214A3.957 3.957 0 0117 9a4 4 0 010 8 1 1 0 000 2 6 6 0 00.309-11.985z"
  }));
}